export const checkEqualOrIncludes = <T extends string | number | Date>(arrayOrSingle: T | T[], value: T): boolean =>
  arrayOrSingle && Array.isArray(arrayOrSingle) ? arrayOrSingle.includes(value) : arrayOrSingle === value;
